module.exports = __webpack_public_path__ + "static/media/collectpay.a0e45bda.png";